const pad = (s, size: number) => {
  let r = s.toString()
  while (r.length < size) {
    r = '0' + r
  }
  return r
}

export const calcLevel = (data: any, settings?: any) => {
  let value = 0
  switch (data.type) {
    case 'cryo':
      if (data.capacity == 181 && data.dporhe ?.toUpperCase() === "DP") {
        value = (data.sensor1 - 400) / 832;
      } else {
        value = (data.sensor1 - 400) / (2000 - 400);
      }
      break
    case 'gasmatic':
      let h = null
      let m = null
      let l = null

      if (data.capacity != undefined && data.capacity == 181 || data.capacity === 212) {
        value = 0;
        if ((data.sensor2 >= data.sensor3) && (data.sensor1 >= data.sensor3)) {
          l = 0.00248815 * Math.pow(data.sensor2, 1) - 2.81447
          value = l
        }
        else if (data.sensor3 >= data.sensor1) {
          h = 0.0000000307551 * Math.pow(data.sensor1, 3) - 0.000147089 * Math.pow(data.sensor1, 2) + 0.234722 * Math.pow(data.sensor1, 1) - 124.944
          value = h
        }
        else if (data.sensor1 >= data.sensor3) {
          m = -0.000845145 * Math.pow(data.sensor3, 1) + 1.89794
          value = m
        }
      }
      else {
        if (data.sensor1 < 2000 && data.sensor2 < 1700 && data.sensor3 > 1300) {
          h =
            0.0000025904 * Math.pow(data.sensor1, 3) -
            0.0145087306 * Math.pow(data.sensor1, 2) +
            27.136353416 * data.sensor1 -
            16881.380030338
        }

        if (data.sensor1 > 1900) {
          m =
            0.0000008911 * Math.pow(data.sensor2, 3) -
            0.0036186446 * Math.pow(data.sensor2, 2) +
            4.9591256958 * data.sensor2 -
            2209.2191160086
        } else if (data.sensor1 < 1800 && data.sensor3 > 1900) {
          m =
            -0.000000049 * Math.pow(data.sensor2, 3) +
            0.0002339452 * Math.pow(data.sensor2, 2) -
            0.4074173825 * data.sensor2 +
            299.6234960314
        } else if (data.sensor1 < 1800 && data.sensor3 < 1750) {
          m = -0.0001502951 * Math.pow(data.sensor2, 2) + 0.6516106126 * data.sensor2 - 685.2743688738
        }

        if (data.sensor2 > 1700 && data.sensor3 > 1700) {
          l =
            0.000001753 * Math.pow(data.sensor3, 3) -
            0.0100024267 * Math.pow(data.sensor3, 2) +
            19.0735497589 * data.sensor3 -
            12120.4216989476
        } else if (data.sensor1 > 1800 && data.sensor2 < 1400) {
          l =
            -0.0000001194 * Math.pow(data.sensor3, 3) +
            0.0005979271 * Math.pow(data.sensor3, 2) -
            1.0241814188 * data.sensor3 +
            673.4216992321
        }

        let c = 0
        value = 0
        if (h !== null) {
          value += h
          c++
        }

        if (m !== null) {
          value += m
          c++
        }

        if (l !== null) {
          value += l
          c++
        }

        value = value / c / 100
      }
      break
    case 'bulk':
      if ((settings || {}).formula) {
        let level = data.sensor1
        if (settings.invert) {
          level = -1 * level
        }
        value = eval(settings.formula.replace(/x/g, level)) / 100
      }
      break
    case 'mopeka':
      let height = 125
      if ((settings || {}).cm) {
        height = settings.cm
      }
      value = data.sensor1 / height
      break
    case 'manifold':
      let pvalue
      if (data.pvalue != undefined) {
        pvalue = data.pvalue;
      }
      else {
        pvalue = 300;
      }
      value = (data.sensor1 / pvalue) / 10
      break
    default:
  }

  if ((settings || {}).span) {
    let low = settings.span.low / 100
    let high = settings.span.high / 100

    value = (value - low) / (high - low)
  }

  return value
}

export const convertRaw = (raw: string) => {
  const modbus = binary => {
    let sign = parseInt(binary[0])
    let exponent = parseInt(binary.substring(1, 9), 2)
    let mantis = parseInt(binary.substring(9, 32), 2)

    let value = Math.pow(-1, sign) * (1.0 + mantis / 8388608) * Math.pow(2, exponent - 127)
    return value
  }

  let data: any = {}

  // Get Status Bits
  data.status = pad(parseInt(raw.substring(0, 2), 16).toString(2), 8)

  // Get Main Battery Voltage
  //data.mbat = parseInt(raw.substring(2, 4), 16) / 62    //Old formula
  data.mbat = parseInt(raw.substring(2, 4), 16) / 63.75   // New formula
  // Get Secondary Battery Voltage
  //data.sbat = (parseInt(raw.substring(4, 6), 16) / 62) * 4       //Old formula
  data.sbat = (parseInt(raw.substring(4, 6), 16) / 63.75) * 4.14  // New formula

  switch (data.status.substring(4, 7)) {
    case '000': // Cryo
      data.type = 'cryo'
      break
    case '001': // Bulk
      data.type = 'bulk'
      break
    case '010': // Gasmatic
      data.type = 'gasmatic'
      break
    case '011': // Mopeka
      data.type = 'mopeka'
      break
    case '100': // Manifold
      data.type = 'manifold'
      break
    default:
      data.type = 'unknown'
  }

  switch (data.type) {
    case 'cryo':
      data.sensor1 = parseInt(raw.substring(6, 10), 16)
      break
    case 'gasmatic':
      data.sensor1 = parseInt(raw.substring(6, 10), 16)
      data.sensor2 = parseInt(raw.substring(14, 18), 16)
      data.sensor3 = parseInt(raw.substring(10, 14), 16)
      break
    case 'bulk':
      data.sensor1 = 10197.1621297792 * modbus(pad(parseInt(raw.substring(6, 14), 16).toString(2), 32))
      data.sensor2 = modbus(pad(parseInt(raw.substring(14, 22), 16).toString(2), 32))
      break
    case 'mopeka':
      data.mac = raw.substring(12, 14) + raw.substring(10, 12) + raw.substring(8, 10)
      data.sbat = (parseInt(raw.substring(4, 6), 16) / 255) * 2 + 1.5
      data.sensor1 = parseInt(raw.substring(6, 8), 16) * 0.3 * 2.54
      break
    case 'manifold':
      data.mac =
        raw.substring(12, 14) +
        raw.substring(10, 12) +
        raw.substring(8, 10) +
        raw.substring(6, 8) +
        raw.substring(4, 6) +
        raw.substring(2, 4)
      data.sensor1 = parseInt(raw.substring(16, 18) + raw.substring(14, 16), 16)
      data.mbat = parseInt(raw.substring(18, 20), 16) / 62
      data.sbat = parseInt(raw.substring(20, 22), 16)
      break
    default:
  }

  return data
}

export const sensorHistory = (historyString: string) => historyString.split(',')
